// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IFleetType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    active: boolean;
    sortOrder: number;
}

export class FleetType implements IFleetType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public active: boolean;
    public sortOrder: number;

    /**
		Returns PermanentFleetRegistration FleetType
	**/
    get PermanentFleetRegistration(): IFleetType {
        return this.FromId(1);
    }
    /**
		Returns AllocatedFleetRegistration FleetType
	**/
    get AllocatedFleetRegistration(): IFleetType {
        return this.FromId(2);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Permanent Fleet Registration', displayValue: 'Permanent Fleet Registration', description: 'Two or more vehicles owned and registered to the same entity', active: true, sortOrder: 1 });
        this._dictionary.add('2', { id: 2, value: 'Allocated Fleet Registration', displayValue: 'Allocated Fleet Registration', description: 'A rental fleet of passenger vehicles where the copany has rental locations in two or more states', active: true, sortOrder: 2 });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IFleetType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IFleetType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IFleetType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IFleetType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): IFleetType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
